import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import { PlusCircle, Vote, Film, ShieldCheck } from 'lucide-react';

export function HowItWorks() {
  const { t } = useTranslation();
  const steps = [
    { Icon: PlusCircle, title: t('how.step1_title'), desc: t('how.step1_desc') },
    { Icon: Vote,       title: t('how.step2_title'), desc: t('how.step2_desc') },
    { Icon: Film,       title: t('how.step3_title'), desc: t('how.step3_desc') },
  ];

  return (
    <section className="section">
      <div className="container-narrow">
        <div className="text-center mb-16">
          <h2 className="font-pixel text-4xl sm:text-5xl font-bold tracking-tight">
            {t('how.title')}
          </h2>
          <p className="mt-4 text-kquest-300 text-lg">{t('how.subtitle')}</p>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {steps.map((s, i) => (
            <motion.div
              key={s.title}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-80px' }}
              transition={{ duration: 0.5, delay: i * 0.1 }}
              className="kblock enchant-card p-8 relative overflow-hidden group"
            >
              <div className="absolute top-0 right-0 -mr-10 -mt-10 w-40 h-40 bg-kquest-500/20 rounded-full blur-3xl group-hover:bg-kquest-500/30 transition-all" />
              <div className="relative">
                <div className="w-14 h-14 bg-kquest-700 border-2 border-kquest-500 flex items-center justify-center mb-6"
                     style={{ boxShadow: 'inset 0 -3px 0 0 rgba(0,0,0,0.4), inset 0 3px 0 0 rgba(255,255,255,0.08)' }}>
                  <s.Icon className="w-7 h-7 text-kquest-200" strokeWidth={2} />
                </div>
                <h3 className="font-pixel text-2xl font-semibold mb-3">{s.title}</h3>
                <p className="text-kquest-300 leading-relaxed">{s.desc}</p>
              </div>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.3 }}
          className="mt-12 flex items-center justify-center gap-3 px-6 py-4 max-w-3xl mx-auto block-gold"
        >
          <ShieldCheck className="w-5 h-5 flex-shrink-0" />
          <p className="text-sm font-pixel">{t('how.guarantee')}</p>
        </motion.div>
      </div>
    </section>
  );
}
